import { useDark } from '@vueuse/core';

const COLOR_MODE_STORAGE_KEY = 'gira-brasil-theme';

function applyDocumentColorMode(isDark) {
    document.documentElement.classList.toggle('dark', isDark);
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
}

export function initializeColorMode() {
    const storedMode = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
    applyDocumentColorMode(storedMode === 'dark');
}

export function useColorMode() {
    const isDark = useDark({
        selector: 'html',
        attribute: 'class',
        valueDark: 'dark',
        valueLight: '',
        storageKey: COLOR_MODE_STORAGE_KEY,
        onChanged(isDarkMode) {
            applyDocumentColorMode(isDarkMode);
        },
    });

    return {
        isDark,
    };
}
